export default __webpack_public_path__ + "static/media/ComparisonInactiveLight.89af6cce.svg";